import React from 'react';
import ReportFrame from '../ReportFrame';

export default class PrepayCreditMemosAr extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = { Type: 2 };
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          reportName='Credit Memos AR'
          reportParams={reportParams}
          id='prepaycreditmemosar'
          name='prepaycreditmemosAR'
          title='Prepay Credit Memos AR'
          hiddenParameters={['Type']}
        />
      </div>
    );
  }
}
